import {Component, ElementRef, ViewChild, AfterViewInit} from '@angular/core';

import Cropper from 'cropperjs';

import {
  Dialog,
  DialogRef,
  DialogParams
} from '../../../../dialog/dialog.base';

/**
 * @ignore
 */
@Component({
  selector: 'uex-input-file-crop-image-modal',
  templateUrl: './crop-image.modal.html',
  host: {
    class: 'uex-input-file-crop-image-modal'
  }
})
export class InputFileCropImageModal implements AfterViewInit {
  @ViewChild('cropImg', {static: true}) cropImg: ElementRef;

  constructor(private _dialogRef: DialogRef, private _params: DialogParams) {
    this.dialog = this._dialogRef.dialog;
    this.image = this._params.get('image');
    this.aspectRatio = this._params.get('aspectRatio') == undefined ? { width: 1, height: 1} : this._params.get('aspectRatio');
    this.allowNotCropAction = this._params.get('allowNotCropAction') == undefined ? true : this._params.get('allowNotCropAction');
    this.cropBoxResizable = this._params.get('cropBoxResizable') == undefined ? true : this._params.get('cropBoxResizable');
    this.minWidth = this._params.get('minWidth') == undefined ? 0 : this._params.get('minWidth');
    this.minHeight = this._params.get('minHeight') == undefined ? 0 : this._params.get('minHeight');
    this.zoomable = this._params.get('zoomable') == undefined ? true : this._params.get('zoomable');
  }

  public dialog: Dialog;
  public image: string;
  public aspectRatio: number;
  public minWidth: number = 0;
  public minHeight: number = 0;
  public zoomable: boolean = true;
  public format: string;
  public allowNotCropAction: boolean;
  public cropBoxResizable: boolean;
  private _cropper: Cropper;
  private _new_image: string;

  public ngAfterViewInit() {
  setTimeout(() => {
    const imageElement = this.cropImg.nativeElement as HTMLImageElement;

    const naturalWidth = imageElement.naturalWidth || imageElement.width || 1;
    const naturalHeight =
      imageElement.naturalHeight || imageElement.height || 1;
    const displayWidth =
      imageElement.clientWidth ||
      imageElement.getBoundingClientRect().width ||
      naturalWidth;
    const displayHeight =
      imageElement.clientHeight ||
      imageElement.getBoundingClientRect().height ||
      naturalHeight;

    const scaleX = displayWidth / naturalWidth;
    const scaleY = displayHeight / naturalHeight;

    const minBoxWidth = Math.round((this.minWidth || 0) * scaleX) || 0;
    const minBoxHeight = Math.round((this.minHeight || 0) * scaleY) || 0;

    this._cropper = new Cropper(imageElement, {
      viewMode: 1,
      responsive: true,
      aspectRatio: this.aspectRatio,
      zoomable: this.zoomable,
      minCropBoxWidth: minBoxWidth,
      minCropBoxHeight: minBoxHeight,
      cropBoxResizable: this.cropBoxResizable
      
    });
  }, 100);
}

public apply() {
  if (!this._cropper) {
    this.dialog.close();
    return;
  }

  let canvas = this._cropper.getCroppedCanvas();

  const targetWidth = this.minWidth || canvas.width;
  const targetHeight = this.minHeight || canvas.height;

  if (canvas.width < targetWidth || canvas.height < targetHeight) {
    const resizedCanvas = document.createElement('canvas');
    resizedCanvas.width = targetWidth;
    resizedCanvas.height = targetHeight;
    const ctx = resizedCanvas.getContext('2d');
    if (ctx) {
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(canvas, 0, 0, resizedCanvas.width, resizedCanvas.height);
      canvas = resizedCanvas;
    }
  }

  const newImage = canvas.toDataURL(this.format || 'image/jpeg');
  this.dialog.returnValue(newImage);
  this.dialog.close();
}

  public close() {
    this.dialog.close();
  }
}
